import React from 'react';
import {View} from 'MWC';
import tpl from '../templates/hint';
import PropTypes from 'prop-types';

export default class extends View {
    templates = {
        [this.uiStates.INITIAL]: <div />,
        [this.uiStates.INTERACTIVE]: tpl,
        [this.uiStates.ERROR]: tpl,
        [this.uiStates.STANDBY]: tpl
    };

    constructor(props) {
        super(props);

        this.state = {
            ui: this.uiStates.INITIAL,
            isShown: false
        };

        this.showHintContent = this.showHintContent.bind(this);
        this.hideHintContent = this.hideHintContent.bind(this);

        return this;
    }

    showHintContent(e) {
        this._setHintLocation(e.target);
        this.setState({isShown: true});
    }

    hideHintContent() {
        this.setState({isShown: false});
    }

    _setHintLocation(target) {
        const hintBody = target.querySelector('.hint-body'),
            triangle = target.querySelector('.triangle'),
            hintLeftOffset = 26,
            triangleLeftOffset = 34,
            topOffsetLimit = 150,
            coords = target.getBoundingClientRect();

        this._resetHintStyles(hintBody, triangle);

        if (coords.top > topOffsetLimit) {
            this._drawHintAbove(hintBody, triangle);
        } else {
            this._drawHintBelow(hintBody, triangle);
        }

        hintBody.style.left = `${hintLeftOffset - target.offsetLeft}px`;
        triangle.style.left = `${target.offsetLeft - triangleLeftOffset}px`;
    }

    _drawHintAbove(hintBody, triangle) {
        hintBody.style.bottom = '32px';
        triangle.style.bottom = '-28px';
    }

    _drawHintBelow(hintBody, triangle) {
        hintBody.style.top = '32px';
        triangle.style.transform = 'rotate(180deg)';
        triangle.style.top = '-28px';
    }

    _resetHintStyles(hintBody, triangle) {
        hintBody.style.top = 'auto';
        hintBody.style.bottom = 'auto';

        triangle.style.top = 'auto';
        triangle.style.bottom = 'auto';
        triangle.style.transform = 'rotate(0)';
    }

    static displayName = 'Credit.Views.Hint';

    static contextTypes = {
        app: PropTypes.object
    };
}
